export default {
	footer: {
		'total-received': 'Total received',
		'paid-total': 'Paid total',
		'the-difference': 'The difference'
	},
	previous: 'Previous',
	next: 'Next'
}